import { render, staticRenderFns } from "./WorkflowFormSubmissionDialog.vue?vue&type=template&id=078b8c03&"
import script from "./WorkflowFormSubmissionDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormSubmissionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports